import React, { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { authService } from "../../services/authService";
import {
  PASSWORD_POLICY_HINT,
  validatePasswordStrength,
} from "../../utils/passwordValidation";
import styles from "./resetPassword.module.scss";

const ResetPassword = () => {
  const { token: rawToken } = useParams();
  const token = rawToken ? decodeURIComponent(rawToken) : "";
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!token) {
      setStatus("error");
      setMessage("Lien invalide.");
      return;
    }

    const pwdCheck = validatePasswordStrength(password);
    if (!pwdCheck.valid) {
      setStatus("error");
      setMessage(pwdCheck.message);
      return;
    }

    if (password !== confirmPassword) {
      setStatus("error");
      setMessage("Les mots de passe ne correspondent pas.");
      return;
    }

    setStatus("loading");
    try {
      const res = await authService.resetPassword(token, password);
      setStatus("success");
      setMessage(res?.message || "Mot de passe mis à jour avec succès.");
      setTimeout(() => navigate("/connect"), 1500);
    } catch (err) {
      setStatus("error");
      setMessage(err.message || "Erreur lors de la réinitialisation");
    }
  };

  return (
    <div className={styles.container}>
      <h1>Nouveau mot de passe</h1>

      {message && (
        <div className={status === "error" ? styles.error : styles.success}>
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit} className={styles.form}>
        <label htmlFor="password">Nouveau mot de passe</label>
        <p className={styles.passwordHint}>{PASSWORD_POLICY_HINT}</p>
        <input
          id="password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <label htmlFor="confirmPassword">Confirmer</label>
        <input
          id="confirmPassword"
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />

        <button type="submit" disabled={status === "loading"}>
          {status === "loading" ? "Mise à jour..." : "Mettre à jour"}
        </button>
      </form>

      <div className={styles.back}>
        <Link to="/connect">Retour à la connexion</Link>
      </div>
    </div>
  );
};

export default ResetPassword;

